import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const RecaptchaVerifierWrapper = (props: Props) => {
  const { children } = props;

  return (
    <div>
      <div id="sign-in-button"></div>
      <div>{children}</div>
    </div>
  );
};

export default RecaptchaVerifierWrapper;
